import { forEach } from './utilities'
const TweenLite = window.TweenLite;
const Power3 = window.Power3;

const topBar = document.querySelector('.top-bar');

forEach( document.querySelectorAll( '.book-now' ), (btn) => {
  btn.addEventListener( 'click' , e => {
    e.preventDefault();

    const tbh = topBar.offsetHeight;
    const id = e.target.getAttribute('href').substr(1);
    const target = document.getElementById( id );
    const top = (typeof window.scrollY === 'undefined' ? window.pageYOffset : window.scrollY);
    const scrollTo = target.getBoundingClientRect().top + top - tbh;

    TweenLite.to(window, 1, {
      scrollTo,
      ease: Power3.easeInOut
    });
  });
});


/** WEBPACK FOOTER **
 ** ./src/js/book-now-scroll.js
 **/